'use client'

import { Box } from '@mui/material'
import { amber } from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'
import { gs1GosterimParcalari } from '@/utils/dataMatrixParser'

/** Ham karekodda 01 / 21 / 17 / 10 ayraçlarını amber gösterir; kopyalanan metin düz kalır. */
export default function Gs1HamKarekodMetni({ ham }: { ham: string }) {
  const theme = useTheme()
  const ayrac = theme.palette.mode === 'dark' ? amber[300] : amber[700]
  const parcalar = gs1GosterimParcalari(ham)
  return (
    <>
      {parcalar.map((p, i) => (
        <Box
          key={`${i}-${p.tur}-${p.metin.slice(0, 12)}`}
          component="span"
          sx={p.tur === 'ai' ? { color: ayrac, fontWeight: 800 } : undefined}
        >
          {p.metin}
        </Box>
      ))}
    </>
  )
}
